<template lang="pug">
  .d3map
    .d3map_svgwrapper(ref="svgwrapper")
    .d3map_mapToolTip
      maptooltip(v-bind:value="hovered_value" v-bind:color="hovered_color" v-bind:location="hovered_locname" v-bind:mouse="mouse" v-show="hovered")

</template>
<script>
  import {mapGetters,mapState,mapActions} from 'vuex';
  import * as d3 from 'd3';

  import MapToolTip from './maptooltip.vue';

  //console.log(d3);

  export default {
    data: function(){
      return {
        svg: undefined,
        paths: undefined,
        eventcapture: undefined,
        geopath: undefined,
        projection: undefined,
        scale: 1,
        zoom: undefined,
        zoom_button: {
          plus: undefined,
          minus: undefined
        },
        hovered_location: undefined,
        hovered: false,
        mouse:{
          x: 0,
          y: 0
        }
      }
    },
    computed: {
      ...mapState([
        'lang',
        'size',
        'map',
        'selected',
        'legend',
        'update_time',
      ]),
      ...mapGetters([
        'get_location_data'
      ]),
      projection_scale(){
        return this.size.svg.width;
      },
      hovered_color: function(){
        let pref = this.get_location_data(this.hovered_location);
        if( pref ){
          return '#' + this.legend[pref.api_data.rankgroup];
        }
        return '#000';
      },
      hovered_value: function(){
        let pref = this.get_location_data(this.hovered_location);
        if( pref ){
          const trancate_digit = (this.selected.type.value === 'Life_expectancy' || this.selected.type.value === 'HALE') ? 10 : 1000;
          return Math.floor( pref.api_data.value  * trancate_digit) / trancate_digit;
        }
        return 0;
      },
      hovered_locname: function() {
        if (this.hovered_location) {
          let pref = this.get_location_data(this.hovered_location);
          if( pref ){
            return /ja/.test(this.lang) ? pref.properties.name_local : pref.properties.name;
          }
        }
        return '';
      }
    },
    watch: {
      "update_time": function(val, oldVal){
        //console.log('***********', this.map, arguments);
        if( oldVal !== 0 ){
          this.update_map();

        }else{
          this.draw_map();
        }
      },
      'size.timestamp': function(){
        //resize
        this.update_map();
      }

    },
    mounted: function(){
      this.make_svg();
      this.init();
      this.add_eventcapture();
      this.add_pathgroup();
      this.make_ui();
      this.set_zoom();

    },
    methods: {
      ...mapActions([
        'changeMode',
        'modifyLocations',
      ]),
      /**
       * Handler
       * 折れ線グラフのパネルを表示するためのイベントハンドラ。バブリングが目的
       */
      openLinegraph: function(location){
        this.changeMode('linegraph');
        this.modifyLocations([0, location]);
      },
      /**
       * d3.jsで地図を描くための変数の初期化を行う
       */
      init: function(){
        this.projection = d3.geoMercator()
          .scale(this.projection_scale);

        this.geopath = d3.geoPath()
          .projection(this.projection);
      },
      /**
       * 地図を描くためのSVGタグを生成
       */
      make_svg: function(){
        this.svg = d3.select(this.$refs.svgwrapper)
          .append('svg')
          .attr('class', 'd3map_svg')
      },
      /**
       * 地図のpathを追加するグループを作成
       */
      add_pathgroup: function() {
        this.paths = this.eventcapture
          .append('g')
          .attr('class', 'd3map_paths')
      },
      /**
       * マウスイベントを受け取る板の追加
       */
      add_eventcapture: function(){
        this.eventcapture = this.svg.append('g')
          .attr('class', 'd3map_eventcapture')
        this.eventcapture.append('rect')
          .attr('class', 'd3map_bg')
          .attr('x',0)
          .attr('y', 0)
      },
      /**
       * 地図を描画
       */
      draw_map: function(){
        //console.log( 'draw_map');
        let self = this;
        this.projection
          .center( d3.geoCentroid(this.map) )
          .translate([this.size.svg.width / 2, this.size.svg.height / 2])
        this.geopath.projection(this.projection);

        this.eventcapture
          .select('.d3map_bg')
          .attr('width', this.size.svg.width)
          .attr('height', this.size.svg.height)

        this.paths
          .selectAll('path')
          .data(this.map.features)
          .enter()
          .append('path')
          .attr('d', this.geopath)
          .attr('class', function(d){
            let name = d.properties.name.toLowerCase();
            return ['d3map_prefecture-' + name, 'd3map_prefecture'].join(' ');
          })
          .attr('fill', function(d){
            //console.log( index, d, d.properties, d['api_data'], d.api_data.rank, d.api_data.rank/11, Math.floor(d.api_data.rank / 11), self.legend[Math.floor(d.api_data.rank / 11)]);
            return '#' + self.legend[d.api_data.rankgroup];
          })
          .on('mouseover', function(d){
            //console.log( this, d3.event);
            self.hovered = true;
            self.hovered_location = d.properties.name;
            self.mouse.x = d3.event.offsetX;
            self.mouse.y = d3.event.offsetY;
          })
          .on('mouseout',function(){
            self.hovered = false;
          })
          .on('click', (d) => {
            //console.log('click', d.properties.name);
            this.openLinegraph(d.properties.name);
          })

        this.zoom.scaleTo(this.eventcapture, this.scale);

      },
      /**
       * 地図を再描画
       */
      update_map: function(){
        //console.log( 'update_map');
        var self = this;

        this.eventcapture
          .select('.d3map_bg')
          .attr('width', this.size.svg.width)
          .attr('height', this.size.svg.height)

        this.paths
          .selectAll('path')
          .data(this.map.features)
          .transition()
          .attr('fill', function(d){
            //console.log( index, d, d.properties, d['api_data'], d.api_data.rank, d.api_data.rank/11, Math.floor(d.api_data.rank / 11), self.legend[Math.floor(d.api_data.rank / 11)]);
            let color = self.legend[d.api_data.rankgroup];
            return '#' + color;
          })
      },
      /**
       * 拡縮機能の追加
       */
      set_zoom: function(){
        let self = this;
        let zoom = d3.zoom()
          .on('zoom', function(){
            //console.log('zoom', this, arguments, d3.event);
            if( d3.event && d3.event.sourceEvent && d3.event.sourceEvent.type == "click"){
              self.paths.transition().attr('transform', d3.event.transform);
            }else{
              self.paths.attr('transform', d3.event.transform);
            }
            self.scale = d3.event.transform.k;
          });

        this.eventcapture.call(zoom)
          .style('pointer-event', 'all');

        this.zoom = zoom;
      },
      /**
       * 画面左のズームボタンと判例を作成
       */
      make_ui: function(){
        this.make_zoom_button();
        this.add_legend();
      },
      /**
       * ズームボタン作成
       */
      make_zoom_button(){
        let self = this;

        let zoombuttons = this.svg.append('g')
          .classed('d3map_zoom', true)
          .attr('transform', 'translate(20, 20)')

        // connection bar
        zoombuttons.append('rect')
          .attr('x', 12)
          .attr('y', 27)
          .attr('width', 3)
          .attr('height', 3)

        
        // plus button
        this.zoom_button.plus = zoombuttons.append('g')
          .classed('d3map_zoombutton d3map_zoombutton-plus', true);

        this.zoom_button.plus.append("circle")
          .attr("class", "d3map_circle")
          .attr('cx', 27/2)
          .attr('cy', 27/2)
          .attr('r', 25/2);

        this.zoom_button.plus.append("rect")
          .attr("class", "d3map_mark")
          .attr('x', 12)
          .attr('y', 8)
          .attr('width', 3)
          .attr('height', 11)

        this.zoom_button.plus.append("rect")
          .attr("class", "d3map_mark")
          .attr('x', 8)
          .attr('y', 12)
          .attr('width', 11)
          .attr('height', 3)


        this.zoom_button.plus.on('click', function(){
          //console.log( d3.zoomIdentity, self.zoom.transform);
          self.scale = Math.min(8, self.scale * 2);
          self.zoom.scaleTo(self.eventcapture, self.scale)
        })

        // minus button
        this.zoom_button.minus = zoombuttons.append('g')
          .classed('d3map_zoombutton d3map_zoombutton-minus', true)
          .attr('transform','translate(0, 30)')

        this.zoom_button.minus.append("circle")
          .attr("class", "d3map_circle")
          .attr('cx', 27/2)
          .attr('cy', 27/2)
          .attr('r', 25/2);

        this.zoom_button.minus.append("rect")
          .attr("class", "d3map_mark")
          .attr('x', 8)
          .attr('y', 12)
          .attr('width', 11)
          .attr('height', 3)

        this.zoom_button.minus.on('click', function(){
          self.scale = Math.max(1/8, self.scale / 2);
          self.zoom.scaleTo(self.eventcapture, self.scale);
        })
      },
      /**
       * 判例追加
       */
      add_legend(){
        let legend_bar = this.svg.append('g')
          .classed('d3map_legend', true)
          .attr('transform', 'translate(18, 90)')

        let legend_gradient = legend_bar.append('g')
          .classed('d3map_legendGradient', true)
          .attr('transform', 'translate(11, 15)')

        // bar
        legend_gradient.selectAll('rect')
          .data(this.legend)
          .enter()
          .append('rect')
          .attr('x', 0)
          .attr('y', function(data, index){
            return index * 20
          })
          .attr('width', 8)
          .attr('height', 20)
          .attr('fill', function(data){
            return '#' + data
          })

        // upper circle
        let high = legend_bar.append('g')
          .classed('d3map_legendLabel d3map_legendLabel-high', true)

        high.append('circle')
          .classed('d3map_legendLabelBase d3map_legendLabelBase-high', true)
          .attr('cx', 30/2)
          .attr('cy', 30/2)
          .attr('r', 30/2)

        high.append('text')
          .attr('font-size', '10px')
          .attr('text-anchor', 'middle')
          .attr('x', 30/2)
          .attr('y', 35/2)
          .text('High')


        // lower circle
        let low = legend_bar.append('g')
          .classed('d3map_legendLabel d3map_legendLabel-low', true)
          .attr('transform', 'translate(0, 220)')

        low.append('circle')
          .classed('d3map_legendLabelBase d3map_legendLabelBase-low', true)
          .attr('cx', 30/2)
          .attr('cy', 30/2)
          .attr('r', 30/2)

        low.append('text')
          .attr('font-size', '10px')
          .attr('text-anchor', 'middle')
          .attr('x', 30/2)
          .attr('y', 35/2)
          .text('Low')

      }
    },
    components: {
      maptooltip: MapToolTip
    }
  }

</script>
<style lang="sass">
  .d3map
    height: 100%
    &_svgwrapper
      height: 100%
    &_svg
      width: 100%
      height: 100%
    &_prefecture
      //fill: #c00
      cursor: pointer
      &:hover
        fill: #000
    &_eventcapture
      fill: #fff
    &_bg
      fill: #fff
    &_zoombutton
      cursor: pointer
      &:hover
        .d3map
          &_circle
            fill: #F0DC00
    &_circle
      fill: #fff
      stroke: #000
      stroke-width: 2px
      transition: fill .1s linear
    &_legend
      &Label
        &Base
          &-high
            fill: #FFD600
          &-low
            fill: #004400
        &-high
        &-low
          text
            fill: #fff
    &_mapToolTip
      position: absolute
      left: 0
      top: 0

</style>